import React, { useState } from "react";
import { createBooking } from "../services/bookingService";
import "./BookingFormData.css";
import StateModal from "./StateModal";

export default function BookingForm({ selectedPackage }) {

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    travelDate: "",
    persons: 1,
    safariInterest: "",
    message: ""
  });

  const initialForm = {
    fullName: "",
    email: "",
    phone: "",
    travelDate: "",
    persons: 1,
    safariInterest: "",
    message: ""
  };

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [statusValue, setStatusValue] = useState("error");

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: type === "number" ? Number(value) : value
    }));

    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.fullName.trim())
      newErrors.fullName = "Full name is required";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.email)
      newErrors.email = "Email is required";
    else if (!emailRegex.test(form.email))
      newErrors.email = "Enter valid email";

    const phoneRegex = /^[6-9]\d{9}$/;

    if (!form.phone)
      newErrors.phone = "Phone required";
    else if (!phoneRegex.test(form.phone))
      newErrors.phone = "Enter valid phone";

    if (!form.travelDate)
      newErrors.travelDate = "Travel date required";

    if (!form.persons || form.persons < 1)
      newErrors.persons = "Minimum 1 person";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setSubmitting(true);

      const response = await createBooking(form);

      setModalOpen(true);
      setBookingId(response.data.bookingid);

      if (response.status === 200) {
        setStatusValue("success");
      }

    } catch {
      setModalOpen(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="bf-card" onSubmit={handleSubmit} noValidate>

      {/* ✅ SAFE TITLE */}
      <h2 className="bf-title">
        Plan Your Ranthambore Tour
      </h2>

      {selectedPackage && (
        <div className="selected-package">
          Selected Package: <strong>{selectedPackage}</strong>
        </div>
      )}

      {/* ✅ SAFE DESCRIPTION */}
      <div className="step-label">
        Share your travel details and our team will help you plan a suitable Ranthambore tour package with safari experience.
      </div>

      <div className="bf-grid">

        <div className="bf-field">
          <label className="bf-label">Full Name</label>
          <input name="fullName" className="bf-input" value={form.fullName} onChange={handleChange} />
          {errors.fullName && <span className="bf-error">{errors.fullName}</span>}
        </div>

        <div className="bf-field">
          <label className="bf-label">Email</label>
          <input name="email" className="bf-input" value={form.email} onChange={handleChange} />
          {errors.email && <span className="bf-error">{errors.email}</span>}
        </div>

        <div className="bf-field">
          <label className="bf-label">Phone</label>
          <input name="phone" className="bf-input" value={form.phone} onChange={handleChange} placeholder="9876543210" />
          {errors.phone && <span className="bf-error">{errors.phone}</span>}
        </div>

        {/* ✅ RENAMED FIELD */}
        <div className="bf-field">
          <label className="bf-label">Travel Date</label>
          <input type="date" name="travelDate" className="bf-input" value={form.travelDate} onChange={handleChange} />
          {errors.travelDate && <span className="bf-error">{errors.travelDate}</span>}
        </div>

        <div className="bf-field">
          <label className="bf-label">Number of Travelers</label>
          <input type="number" name="persons" min="1" className="bf-input" value={form.persons} onChange={handleChange} />
          {errors.persons && <span className="bf-error">{errors.persons}</span>}
        </div>

        {/* ✅ SAFE OPTIONAL SAFARI INTEREST */}
        <div className="bf-field">
          <label className="bf-label">Interested in Safari Experience?</label>
          <select name="safariInterest" className="bf-input" value={form.safariInterest} onChange={handleChange}>
            <option value="">Select Option</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </div>

        {/* ✅ MESSAGE FIELD */}
        <div className="bf-field full-width">
          <label className="bf-label">Additional Requirements (Optional)</label>
          <textarea
            name="message"
            className="bf-input"
            value={form.message}
            onChange={handleChange}
            placeholder="Hotel preference, budget, number of days, etc."
          />
        </div>

      </div>

      {/* ✅ SAFE BUTTON */}
      <button className="bf-button" disabled={submitting}>
        {submitting ? "Submitting..." : "Get Tour Plan"}
      </button>

      <StateModal
        isOpen={modalOpen}
        bookingId={bookingId}
        status={statusValue}
        onClose={() => {
          setModalOpen(false);
          setForm(initialForm);
        }}
      />

    </form>
  );
}